import { clsx } from 'clsx'
import { memo } from 'preact/compat'

import { Card, InfoIcon, Typography } from 'components/UI/atoms'

interface Props {
	description: string
	hidding?: boolean
	id: string
	isSelected: boolean
	loading?: boolean
	name: string
	onClick: (id: string) => void
	subtitle: string
}

const FeaturesCard = memo(
	({
		description,
		id,
		isSelected,
		name,
		subtitle,
		loading,
		hidding,
		onClick
	}: Props) => (
		<Card
			className={clsx(
				'relative h-48 max-w-[400px] border-2 bg-black-800 hover:border-black-200',
				isSelected
					? ' border-product hover:border-product'
					: 'border-transparent',
				hidding && 'hidden'
			)}
			id={id}
			onClick={() => onClick(id)}
		>
			<InfoIcon className='absolute right-5' />

			<Typography
				class='overflow-hidden text-ellipsis'
				loading={loading}
				text={name}
				variant='label1'
			/>
			<Typography
				class='mt-1'
				color='text-black-200'
				loading={loading}
				text={subtitle}
				variant='text3'
			/>
			<Typography
				class='mt-6'
				color='text-black-200'
				loading={loading}
				text={description}
				variant='text3'
			/>
		</Card>
	)
)

export { FeaturesCard }
